// Rótulos amigáveis em PT-BR para os códigos internos (ações e motivos).
// Objetivo: NADA em inglês/snake_case pode vazar para a tela — todos os
// clientes são BR e o painel precisa ser entendível por leigos de primeira.

export const OUTCOME_META = {
  ALLOW: { label: 'Libera', color: '#067647', bg: '#ecfdf3', dot: '#12b76a' },
  BLOCK: { label: 'Bloqueia', color: '#b42318', bg: '#fef3f2', dot: '#f04438' },
  DELAY: { label: 'Atrasa', color: '#b54708', bg: '#fffaeb', dot: '#f79009' },
  REQUIRE_APPROVAL: { label: 'Aprovação', color: '#5925dc', bg: '#f4f3ff', dot: '#7a5af8' },
  TAG_ONLY: { label: 'Marca', color: '#475467', bg: '#eef1f5', dot: '#98a2b3' },
  TRANSFORM: { label: 'Ajusta', color: '#0e7090', bg: '#ecfdff', dot: '#06aed4' },
  PASS_THROUGH: { label: 'Passou', color: '#475467', bg: '#f2f4f7', dot: '#98a2b3' }
}

// Rótulo curto da AÇÃO (o que a regra faz), para chips de regra.
export const ACTION_LABELS = {
  ALLOW: 'Libera', BLOCK: 'Bloqueia', DELAY: 'Atrasa',
  REQUIRE_APPROVAL: 'Pede aprovação', TAG_ONLY: 'Só marca'
}

export const SOURCE_LABELS = {
  any: 'Todas as origens', ixc: 'IXC', sgp: 'SGP', mkauth: 'MK-Auth', atlaz: 'Atlaz', generic: 'Genérico',
  unknown: 'Não identificada'
}

// Motivos internos (action.params.reason e supressão) → frase amigável.
export const REASON_LABELS = {
  // decisões das receitas
  duplicate_within_window: 'Mensagem repetida',
  daily_recipient_limit: 'Limite diário atingido',
  min_interval: 'Intervalo mínimo não respeitado',
  suppressed_recipient: 'Número na lista de bloqueio',
  has_real_due_date: 'Tem vencimento de verdade',
  specific_due_date: 'Vencimento específico',
  billing_too_early: 'Cobrança cedo demais',
  within_billing_window: 'Dentro da janela de cobrança',
  overdue_only: 'Somente faturas vencidas',
  amount_too_low: 'Valor abaixo do mínimo',
  high_value_billing: 'Cobrança de valor alto',
  unresolved_variable: 'Variável não preenchida',
  unclassified_message: 'Mensagem não reconhecida',
  outside_business_hours: 'Fora do horário comercial',
  marketing_outside_hours: 'Marketing fora do horário',
  no_sunday: 'Envio no domingo',
  unblock_always: 'Desbloqueio (sempre passa)',
  vip_recipient: 'Lista de sempre enviar',
  not_allowed_by_any_rule: 'Não liberado por nenhuma regra',
  budget_cap_reached: 'Teto de envios atingido',
  inadimplencia_antiga: 'Inadimplência antiga',
  no_rule_matched: 'Nenhuma regra se aplicou',
  allowed_after_rules: 'Liberada pelas regras',
  allowed_by_rules: 'Liberada pelas regras',
  pass_through: 'Sem filtro',
  smartfilter_off: 'Filtro desligado',
  smartfilter_error: 'Erro interno (liberado por segurança)',
  // motivos da lista de bloqueio
  manual: 'Manual',
  user_request: 'Pedido do cliente',
  complaint: 'Reclamação',
  auto_complaint: 'Reclamação automática'
}

// Fallback: transforma um código desconhecido (snake_case) em algo legível.
export function prettify(code) {
  if (!code) return ''
  return String(code).replace(/[_-]+/g, ' ').replace(/^\w/, (c) => c.toUpperCase())
}

export function labelReason(code) {
  if (!code) return ''
  if (REASON_LABELS[code]) return REASON_LABELS[code]
  if (String(code).startsWith('rule:')) return `Regra: ${String(code).slice(5)}`
  return prettify(code)
}

export function labelAction(type) {
  return ACTION_LABELS[type] || prettify(type)
}

export function labelSource(src) {
  return SOURCE_LABELS[src] || src || 'Todas as origens'
}

// Intenção detectada pelo parser → frase amigável (nada de snake_case na tela).
export const INTENT_LABELS = {
  cobranca: 'Cobrança',
  atraso: 'Em atraso',
  desbloqueio: 'Desbloqueio',
  marketing: 'Marketing',
  aviso: 'Aviso',
  confirmacao: 'Confirmação',
  pesquisa: 'Pesquisa',
  boasvindas: 'Boas-vindas',
  unknown: 'Não reconhecida'
}

export function labelIntent(code) {
  if (!code) return ''
  return INTENT_LABELS[code] || prettify(code)
}
